// @ts-nocheck
import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import PageLoad from "components/PageLoad/PageLoad";
import useAccount from "classes/Accounts/hooks/useAccount";
import { t } from "i18next";
import genRequest from "includes/request";
import documents_treat from "includes/documents_treat";
import useTemplate from "hooks/useTemplate";

export default function DocumentsController(props) {
	const { account } = useAccount();
	const { template } = useTemplate();
	const [TypeId] = useState(props.typeId ? props.typeId : 1);
	// const { setSiteSelected } = useFilterContext();
	const [CompanyId] = useState(
		props.companyId ? props.companyId : account.companyId
	);
	const [Site, setSite] = useState({
		value: 0,
		label: t("Commons.ALL_SITES"),
	});
	const [SiteId, setSiteId] = useState(props.siteId ? props.siteId : false);
	const [State] = useState(props.state ? props.state : "published");
	const [CurDoc, setCurDoc] = useState(false);
	const [Saved, setSaved] = useState(false);
	const QCL = useQueryClient();

	function setCurSite(new_site) {
		if (new_site.value === 0) setSiteId(false);
		else setSiteId(new_site.value);
		setSite(new_site);
	}

	function getRetrieveReq() {
		if (Saved)
			return {
				queryKey: [
					"DocumentsController",
					"Documents",
					"me/saved-documents",
					account.employeeId,
				],
				queryFn: fetchSavedDocs,
			};
		if (SiteId)
			return {
				queryKey: [
					"DocumentsController",
					"Documents",
					"AllDocumentsOfSiteTyped",
					TypeId,
					SiteId,
				],
				queryFn: retrieveSiteDocs,
			};
		if (!CompanyId)
			return {
				error: true,
			};
		return {
			queryKey: [
				"DocumentsController",
				"Documents",
				"AllDocumentsOfCompanyTyped",
				TypeId,
				CompanyId,
			],
			queryFn: retrieveCompanyDocs,
		};
	}

	// const fetchUserSite = async () =>
	// 	genRequest("Sites/" + account.siteId).then((resp) =>
	// 		resp ? [resp] : []
	// 	);

	const retrieveSiteDocs = async (forceSite) => {
		let siteId = forceSite ? forceSite : SiteId;
		let req = genRequest(
			"documents/site/" + SiteId + "/type/" + TypeId
		).then(
			(resp) => {
				return documents_treat(resp, false, false, { siteId: siteId });
			},
			() => []
		);
		return req;
	};

	const fetchCompanyDoc = async () => {
		let prom = genRequest(
			"documents/company/" + CompanyId + "/type/" + TypeId
		).then(
			(resp) => {
				if (!resp?.length) return [];
				let mapped = resp.map((a) => {
					let ret = { ...a };
					ret.companyId = CompanyId;
					return ret;
				});
				return mapped;
			},
			() => { }
		);
		return prom;
	};

	const retrieveCompanyDocs = async () => {
		let prom = new Promise((resolve, reject) => {
			let proms = [];
			proms.push(fetchCompanyDoc());
			if (!account.isTemp) proms.push(genRequest("me/target-documents"));
			// if (isAdmin())
			// 	proms.push(
			// 		genRequest(
			// 			"Documents/TargetsDocumentsOfCompanyTyped/" +
			// 				CompanyId +
			// 				"/" +
			// 				TypeId
			// 		).catch(() => {})
			// 	);
			Promise.all(proms).then((resp) => {
				// Alias id → documentId (documents_treat) before rm_double
				// de-duplicates on documentId: on raw v2 rows every key is
				// undefined and only the first document survived.
				let res = rm_double(
					resp.map((list) =>
						documents_treat(list, false, false, {
							companyId: CompanyId,
						})
					)
				);

				resolve(res);
				return true;
			}, reject);
		});
		return prom;
	};

	const fetchSavedList = async () => {
		let prom = new Promise((resolve, reject) => {
			let req = genRequest(
				"me/saved-documents"
			);

			req.then(
				(resp) => resolve(resp),
				(e) => {
					if (e.response.status === 204) {
						resolve([]);
						return [];
					}
					reject([]);
					return false;
				}
			);
			return req;
		});
		return prom;
	};

	const fetchSavedDocs = async () => {
		let prom = new Promise((resolve, reject) => {
			let docs = [];
			retrieveCompanyDocs()
				.then((resp) => {
					docs = resp;
					return fetchSavedList();
				}, reject)
				.then(
					(lt_docs) => {
						let ret = [];
						if (lt_docs !== '') {
							ret = docs.filter((a) =>
								lt_docs.find((b) => a.documentId === b.documentId)
							);
						}
						resolve(ret);
					},
					() => reject([])
				);
		});
		return prom;
	};

	function rm_double(docs) {
		let arr = [];
		let indexes = [];
		for (let x = 0; x < docs.length; x++)
			for (let y = 0; y < docs[x]?.length; y++)
				if (indexes.indexOf(docs[x][y].documentId) === -1) {
					arr.push(docs[x][y]);
					indexes.push(docs[x][y].documentId);
				}
		return arr;
	}

	function refreshList() {
		let prom = getRetrieveReq();
		QCL.resetQueries(prom.queryKey);
	}

	let prom = getRetrieveReq();

	const { isLoading, data, error } = useQuery(prom);

	if (isLoading)
		return (
			<PageLoad
				background={false}
				color={template?.primaryColor()}
				text={t("Docs.LOADING")}
			/>
		);
	if (error) return <div>{t("Docs.LOAD_ERROR")}</div>;

	if (props.childComponent)
		return (
			<props.childComponent
				curSite={Site}
				setSite={setCurSite}
				savedState={Saved}
				setSaved={setSaved}
				typeId={TypeId}
				docs={data ? data : []}
				title={props.title}
				state={State}
				onPostClick={setCurDoc}
				curDoc={CurDoc}
				account={account}
				refreshList={refreshList}
				{...props.childProps}
			/>
		);
	return false;
}
